import { useIntl } from 'react-intl';

import { ProductNavBar } from '@/components/wpl/product-navbar/src/product-navbar';
import { ProductNavLink } from '@/components/wpl/product-navbar/src/product-navlink';
import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';

export type ContactSalesNavProps = {
	showContactSales: boolean;
};

export const ContactSalesNav = ({ showContactSales }: ContactSalesNavProps) => {
	const intl = useIntl();
	return (
		<ProductNavBar
			productHref={useLocalizedHref('/enterprise')}
			productName="enterprise"
			showFreeHrefButton={false}
			showTextWithoutLogo={true}
			showContactSalesHrefButton={showContactSales}
			freeHref={useLocalizedHref('/enterprise/contact?formType=product-features')}
			ariaLabel={intl.formatMessage({
				id: 'contact-sales-thanks.logo-label',
				defaultMessage: 'Enterprise',
			})}
			dataProductKey="enterpriseContactSales"
		>
			<ProductNavLink
				label={intl.formatMessage({
					id: 'contact-sales.navbar.overview',
					defaultMessage: 'Overview',
				})}
				href={useLocalizedHref('/enterprise')}
			/>
			<ProductNavLink
				label={intl.formatMessage({
					id: 'contact-sales.navbar.cloud',
					defaultMessage: 'Cloud',
				})}
				href={useLocalizedHref('/enterprise/cloud')}
			/>
			<ProductNavLink
				label={intl.formatMessage({
					id: 'contact-sales.navbar.data-center',
					defaultMessage: 'Data Center',
				})}
				href={useLocalizedHref('/enterprise/data-center')}
			/>
			<ProductNavLink
				label={intl.formatMessage({
					id: 'contact-sales.navbar.services',
					defaultMessage: 'Services',
				})}
				href={useLocalizedHref('/enterprise/services')}
			/>
			<ProductNavLink
				label={intl.formatMessage({
					id: 'contact-sales.navbar.resources',
					defaultMessage: 'Resources',
				})}
				href={useLocalizedHref('/enterprise/resources')}
			/>
		</ProductNavBar>
	);
};

ContactSalesNav.displayName = 'ContactSalesNav';
